export class AppRoute {
  private static readonly prefix: string = '/#/';

  //Without prefix

  static readonly errornotfound: string = 'errors/error-notfound';
  static readonly errorinternal: string = 'errors/error-internal';
  static readonly errorUnauthorized: string = 'errors/error-unauthorized';
  static readonly dashboard: string = 'main/dashboard';

  static readonly loginAdmin: string = '/auth/login';

  static readonly bsExpertassignCompany: string =
      'user/bsexpert/bsexpertassigncompany';
  static readonly bsExpertList: string = 'user/bsexpert/list'; //list added
  static readonly bsExpertEdit: string = 'user/bsexpert/edit';
  static readonly bsExpertAdd: string = 'user/bsexpert/add';
  static readonly bsexportReport: string = 'user/bsexpert/report';
  static readonly bsExpertView: string = 'user/bsexpert/view';

  /**System User List **/
  static readonly assignCompany: string = 'user/system/assigncompany';
  static readonly userList: string = 'user/system/list'; //list added
  static readonly userEdit: string = 'user/system/edit';
  static readonly userAdd: string = 'user/system/add';
  static readonly userViewRoute: string = 'user/system/view';
  /****/

  /**Master Management**/

  /**Compliance Path**/
  static readonly complianceList: string = 'master/compliance/list'; //list added
  static readonly complianceEdit: string = 'master/compliance/edit';
  static readonly complianceAdd: string = 'master/compliance/add';
  static readonly complianceViewRoute: string = 'master/compliance/view';

  /**Control**/
  static readonly importControl: string = 'master/control/import';

  /**Question Category**/
  static readonly questionCategoryList: string =
      'master/questioncategory/list';
  static readonly questionCategoryEdit: string =
      'master/questioncategory/edit';
  static readonly questionCategoryAdd: string = 'master/questioncategory/add';
  static readonly questionCategoryViewRoute: string =
      'master/questioncategory/view';

  /**Departments**/
  static readonly departmentList: string = 'master/departments/list';
  static readonly departmentEdit: string = 'master/departments/edit';
  static readonly departmentAdd: string = 'master/departments/add';
  static readonly departmentView: string = 'master/departments/view';

  /**Company Route**/
  static readonly companyList: string = 'main/company/list'; //list added
  static readonly companyUserList: string = 'main/clientuser/list';
  static readonly companySignUpRoute: string = 'main/company/signup';
  static readonly companyAddRoute: string = 'main/company/add';
  static readonly companyEdit: string = 'main/company/edit';
  static readonly companyViewRoute: string = 'main/company/view';
  static readonly clientPermissionRoute: string = 'main/company/permission';
  static readonly editMyCompnayRoute: string = 'main/company/editmycompany';

  //---- Company User Route
  static readonly companyUserListRoute: string = 'main/clientuser/list';
  static readonly companyUserEditRoute: string = 'main/clientuser/edit';
  static readonly companyUserAddRoute: string = 'main/clientuser/add';
  static readonly companyUserViewRoute: string = 'main/clientuser/view';
  static readonly companyUserAssignCompanyRoute: string =
      'main/clientuser/assigncompany';

  //Assessement Route added list
  static readonly assessmenDashboard: string = 'main/dashboard/all';
  static readonly assessmentListRoute: string = 'main/assessment/list';
  static readonly assessmentFillUpRoute: string = 'main/assessment/fillup';
  static readonly assessmentRemediationRoute: string =
      'main/assessment/recommendation';
  static readonly redirectQuestionListRoute: string =
      'main/assessment/redirectquestion/list';
  static readonly reviewCompletedPolicy: string =
      'main/assessment/review/completedpolicy';
  static readonly redirectQuestionAssessorAnswerRoute: string =
      'main/assessment/redirectquestion/assessoranswer';
     
  static readonly redirectQuestionReviewerAnswerRoute: string =
      'main/assessment/redirectquestion/revieweranswer';
  static readonly reviewQuestionRoute: string =
      'main/assessment/reviewquestion';
  static readonly parentAssessmentAddRoute: string =
      'main/assessment/parentassessment/add';
  static readonly parentAssessmentEditRoute: string =
      'main/assessment/parentassessment/edit';
      //Payment
        static readonly paymentPlan: string='main/payment/plan';
    //RiskIntegrator
  static readonly riskIntegrator: string='main/risk-integrator/list';
  static readonly riskIntegratorparentAddRoute: string='main/risk-integrator/parentRiskIntegrators/add';
  static readonly riskIntegratorparentEditRoute: string='main/risk-integrator/parentRiskIntegrators/edit';
  static readonly iskIntegratorEditRoute: string = 'main/risk-integrator/edit';
  static readonly riskIntegratorparentFillUpRoute: string = 'main/risk-integrator/fillup';
  static readonly riskIntegratorReviewUpRoute: string = 'main/risk-integrator/review';
  static readonly riskIntegratorCompletedUpRoute: string = 'main/risk-integrator/completedPolicy';
  static readonly redirectQuestionRiskAnswerRoute: string =  'main/risk-integrator/redirect';
  //Policy ad control management Route
  static readonly policySelectionRoute: string = 'main/policyselection/list'; //list added
  static readonly userRoute: string = 'main/clientuser/'; //list added
  static readonly policySelectionEditRoute: string =
      'main/policyselection/edit';
  static readonly policySelectionQuestionEditRoute: string =
      'main/policyselection/question/edit';
  static readonly policySelectionQuestionAddRoute: string =
      'main/policyselection/question/add';
  static readonly policySelectionCompanyPolicyRoute: string =
      'main/policyselection/companypolicydocument';
  static readonly policySelectionCompanyProcedureRoute: string =
      'main/policyselection/procedure';

  /*: Questionnaire Route*/
  static readonly questionnaireListRoute: string = 'main/question/list'; //list added
  static readonly questionnairImportRoute: string = 'main/question/import';
  static readonly questionnairImportRouteCompany: string =
      'main/clientquestion/import';
  static readonly questionAddRoute: string = 'main/question/add';
  static readonly questionEditRoute: string = 'main/question/edit';
  static readonly assessmentEditRoute: string = 'main/assessment/edit';
  static readonly assessmentCopyRoute: string = 'main/assessment/copy';
  static readonly questionViewRoute: string = 'main/question/view';

  static readonly clientQuestionnaireListRoute: string =
      'main/clientquestion/list'; //list added
  static readonly clientQuestionAddRoute: string = 'main/clientquestion/add';
  static readonly clientQuestionEditRoute: string =
      'main/clientquestion/edit';
  static readonly clientQuestionViewRoute: string =
      'main/clientquestion/view';

  //--Main Title--/ /list add
  static readonly mainTitleListRoute: string = 'master/maintitle/list';
  static readonly mainTitleEditRoute: string = 'master/maintitle/edit';
  static readonly mainTitleAddRoute: string = 'master/maintitle/add';
  static readonly mainTitleViewRoute: string = 'master/maintitle/view';

  //--Sub Title--/ /list add
  static readonly subTitleListRoute: string = 'master/subtitle/list';
  static readonly subTitleEditRoute: string = 'master/subtitle/edit';
  static readonly subTitleAddRoute: string = 'master/subtitle/add';
  static readonly subTitleViewRoute: string = 'master/subtitle/view';

  //--Policy Title--/ /list add
  static readonly policyListRoute: string = 'master/policy/list';
  static readonly policyEditRoute: string = 'master/policy/edit';
  static readonly policyAddRoute: string = 'master/policy/add';
  static readonly policyViewRoute: string = 'master/policy/view';

  static readonly mstServiceListRoute: string = 'master/service/list'; //list added
  static readonly mstServiceEditRoute: string = 'master/service/edit';
  static readonly mstServiceAddRoute: string = 'master/service/add';
  static readonly mstServiceViewRoute: string = 'master/service/view';

  /*: Control Route*/
  static readonly importControlRoute: string = 'master/control/import';

  /*Subscription*/
  static readonly subscriptionListRoute: string = 'main/subscription/list';
  static readonly subscriptionAddRoute: string = 'main/subscription/add';
  static readonly subscriptionEditRoute: string = 'main/subscription/edit';
  static readonly subscriptionViewRoute: string = 'main/subscription/view';

  /*Manage Subscription*/
  static readonly manageSubscriptionListRoute: string =
      'main/clientsubscription/list';
  static readonly manageSubscriptionAddRoute: string =
      'main/clientsubscription/add';
  static readonly manageSubscriptionEditRoute: string =
      'main/clientsubscription/edit';
  static readonly manageSubscriptionViewRoute: string =
      'main/clientsubscription/view';

  /*: Activity Log*/
  static readonly activityLogListRoute: string = 'main/activitylog/list'; //list added

  /*: MyProfile*/
  static readonly changePasswordRoute: string = 'main/profile/changepassword';
  static readonly myProfileRoute: string = 'main/profile/myprofile';

  /*Vs: RoleManagement*/
  static readonly roleManagementRoute: string = 'main/rolemanagement/list'; //list added

  /*SetUp Company Department*/
  static readonly companyDepartmentListRoute: string =
      'master/companydepartments/listcompanydepartment';
  static readonly companyDepartmentEditRoute: string =
      'master/companydepartments/editcompanydepartment';
  static readonly companyDepartmentAddRoute: string =
      'master/companydepartments/addcompanydepartment';

  /**Risk Treatment / Remediation **/
  static readonly remediationListRoute: string = 'main/remediation/list';
  static readonly remediationAddRoute: string = 'main/remediation/add';
  static readonly remediationEditRoute: string = 'main/remediation/edit';
  static readonly remediationFillUpRoute: string = 'main/remediation/fillup';
  static readonly reviewRemediationQuestionRoute: string =
      'main/remediation/reviewquestion';
  static readonly remediationRedirectedQuestionListRoute: string =
      'main/remediation/redirectquestion/list';
  static readonly remediationRedirectQuestionAssessorAnswerRoute: string =
      'main/remediation/redirectquestion/assessoranswer';
  static readonly remediationRedirectQuestionReviewerAnswerRoute: string =
      'main/remediation/redirectquestion/revieweranswer';

  /*Infosec module*/
  static readonly infosecDashboardAllUser: string =
      'main/infosecdashboard/alluser';
  static readonly infosecDashboardSystemAdmin: string =
      'main/infosecdashboard/systemadmin';

  static readonly projectList: string = 'main/infosec/list';
  static readonly projectAdd: string = 'main/infosec/add';
  static readonly projectEdit: string = 'main/infosec/edit';
  static readonly projectViewRoute: string = 'main/infosec/view';

  static readonly projectTask: string = 'main/infosec/task/list';
  static readonly projectTaskEdit: string = 'main/infosec/task/edit';

  static readonly projectTaskResource: string = 'main/infosec/taskreport';

  static readonly projectTimesheetAddRoute: string =
      'main/infosec/timesheet/add';
  static readonly projectTimesheetEditRoute: string =
      'main/infosec/timesheet/edit';
  static readonly projectTimesheetViewRoute: string =
      'main/infosec/timesheet/view';
  static readonly projectTimesheetListRoute: string =
      'main/infosec/timesheet/list/user';
  static readonly projectHoursRequestAdd: string =
      'main/infosec/hoursrequest/add';

  static readonly timeSheetListRoute: string =
      'main/infosec/timesheet/list/all';
  static readonly hoursHistoryListRoute: string =
      'main/infosec/hoursHistory/list';
  static readonly allCompanyProjectHoursHistoryListRoute: string =
      'main/allcompanyproject/hoursHistory/list';
  static readonly allCompanyProjectTimeSheetListRoute: string =
      'main/allcompanyproject/timesheet/list/all';
  static readonly allCompanyProjectList: string =
      'main/allcompanyproject/list';

  static readonly myproject: string = 'main/myproject/list'; //list added
  static readonly myProjectTask: string = 'main/myproject/task';
  static readonly myProjectView: string = 'main/myproject/view';

  /**Client Document File**/
  static readonly clientDocumentListRoute: string = 'main/clientdoc/list'; //list added
  static readonly clientDocumentAddRoute: string = 'main/clientdoc/add';

  /**Company Policy Document**/
  static readonly companyPoicyList: string =
      'master/questioncategory/companypolicy/list';

  static readonly procedureList: string =
      'master/questioncategory/companypolicy/procedure/list';

      static readonly editmycompany: string =
      'main/company/editmycompany';

    /**Payment Route**/
  static readonly cardPayment: string = 'main/payment/card-payment';
  static readonly plan: string = 'main/payment/plan';
  

}

export class FuseConfigHiddenSideBar {
  static hiddenSideBarUrl: string[] = [
      '/auth/login',
      '/main/company/sign-up',
      '/errors',
  ];
}
